import { useRef } from "react";

import {
  areUserPreferencesEqual,
  syncTableUserPreferencesFromServer,
  type UserTablePreferences,
} from "@/shared/utils";

/**
 * Overwrites design-system localStorage from server prefs during render, before
 * child components (Table) mount and read stale localStorage synchronously.
 */
export const useSyncTableUserPreferencesFromServer = (
  serverPreferences: UserTablePreferences | null | undefined,
): void => {
  const hasSyncedServerPrefsRef = useRef(false);
  const syncedServerPrefsRef =
    useRef<UserTablePreferences | null | undefined>(undefined);

  if (
    !hasSyncedServerPrefsRef.current ||
    !areUserPreferencesEqual(
      serverPreferences,
      syncedServerPrefsRef.current,
    )
  ) {
    syncTableUserPreferencesFromServer(serverPreferences);
    syncedServerPrefsRef.current = serverPreferences;
    hasSyncedServerPrefsRef.current = true;
  }
};
